import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × HERMÈS: Artisanal geometry — precision meets savoir-faire
// Woven grids, silk-like reflections, modular equestrian symmetry
export function VasarelyHermesMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Elegant background */}
      <rect x="0" y="0" width="794" height="1123" fill="#F4E8D8" opacity="0.95" />

      <g transform="translate(397 540)">
        {/* Woven grid pattern (artisanal textile) */}
        {Array.from({ length: 20 }).map((_, i) =>
          Array.from({ length: 26 }).map((_, j) => {
            const x = (i - 9.5) * 30;
            const y = (j - 12.5) * 30;
            const weave = (i + j) % 2 === 0;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 12}
                y={y - 12}
                width="24"
                height="24"
                fill={weave ? brand.amber : "#D4A574"}
                opacity={0.3}
              />
            );
          })
        )}

        {/* Silk-like reflective waves */}
        {Array.from({ length: 12 }).map((_, i) => {
          const y = -240 + i * 40;
          const points = Array.from({ length: 40 }).map((_, j) => {
            const x = -300 + j * 15;
            const wave = Math.sin(j * 0.3 + i * 0.2) * 20;
            return `${x},${y + wave}`;
          }).join(" ");
          
          return (
            <polyline
              key={i}
              points={points}
              fill="none"
              stroke={brand.amber}
              strokeWidth="2"
              opacity={0.25}
            />
          );
        })}

        {/* Equestrian symmetry (modular precision) */}
        {[0, 90, 180, 270].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 180;
          return (
            <g key={angle}>
              <rect
                x={Math.cos(rad) * r - 30}
                y={Math.sin(rad) * r - 40}
                width="60"
                height="80"
                fill={brand.amber}
                opacity="0.25"
                rx="8"
              />
              <rect
                x={Math.cos(rad) * r - 25}
                y={Math.sin(rad) * r - 35}
                width="50"
                height="70"
                fill="none"
                stroke="#8B4513"
                strokeWidth="2"
                opacity="0.4"
                rx="6"
              />
            </g>
          );
        })}

        {/* Artisanal precision circles */}
        {Array.from({ length: 15 }).map((_, i) => {
          const r = 40 + i * 18;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={brand.amber}
              strokeWidth="1"
              opacity={0.2 - i * 0.008}
            />
          );
        })}

        {/* Savoir-faire nodes */}
        {[0, 60, 120, 180, 240, 300].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 220;
          return (
            <circle
              key={angle}
              cx={Math.cos(rad) * r}
              cy={Math.sin(rad) * r}
              r="8"
              fill="#8B4513"
              opacity="0.6"
            />
          );
        })}

        {/* Central crafted medallion */}
        <circle cx="0" cy="0" r="60" fill="none" stroke={brand.amber} strokeWidth="3" opacity="0.4" />
        <circle cx="0" cy="0" r="50" fill="#D4A574" opacity="0.15" />
      </g>

      {/* Hermès inscription */}
      <text x="397" y="1000" textAnchor="middle" fontFamily="serif" fontSize="11" fill="#8B4513" opacity="0.6" fontStyle="italic">
        savoir-faire géométrique
      </text>
    </g>
  );
}
